"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpacingBox = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const breakpoints = {
  tablet: '768px',
  desktop: '992px'
};
const allStyles = ({
  $type,
  all = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], all.general && `
    ${[$type]}: ${theme.spacing[all.general]};
  `, all.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${[$type]}: ${theme.spacing[all.tablet]};
    }
  `, all.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${[$type]}: ${theme.spacing[all.desktop]};
    }
  `);
const topStyles = ({
  $type,
  top = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], top.general && `
    ${`${[$type]}-top`}: ${theme.spacing[top.general]};
  `, top.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${`${[$type]}-top`}: ${theme.spacing[top.tablet]};
    }
  `, top.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${`${[$type]}-top`}: ${theme.spacing[top.desktop]};
    }
  `);
const leftStyles = ({
  $type,
  left = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], left.general && `
    ${`${[$type]}-left`}: ${theme.spacing[left.general]};
  `, left.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${`${[$type]}-left`}: ${theme.spacing[left.tablet]};
    }
  `, left.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${`${[$type]}-left`}: ${theme.spacing[left.desktop]};
    }
  `);
const rightStyles = ({
  $type,
  right = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], right.general && `
    ${`${[$type]}-right`}: ${theme.spacing[right.general]};
  `, right.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${`${[$type]}-right`}: ${theme.spacing[right.tablet]};
    }
  `, right.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${`${[$type]}-right`}: ${theme.spacing[right.desktop]};
    }
  `);
const bottomStyles = ({
  $type,
  bottom = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], bottom.general && `
    ${`${[$type]}-bottom`}: ${theme.spacing[bottom.general]};
  `, bottom.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${`${[$type]}-bottom`}: ${theme.spacing[bottom.tablet]};
    }
  `, bottom.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${`${[$type]}-bottom`}: ${theme.spacing[bottom.desktop]};
    }
  `);
const verticalStyles = ({
  $type,
  vertical = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], vertical.general && `
    ${`${[$type]}-top`}: ${theme.spacing[vertical.general]};
    ${`${[$type]}-bottom`}: ${theme.spacing[vertical.general]};
  `, vertical.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${`${[$type]}-top`}: ${theme.spacing[vertical.tablet]};
      ${`${[$type]}-bottom`}: ${theme.spacing[vertical.tablet]};
    }
  `, vertical.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${`${[$type]}-top`}: ${theme.spacing[vertical.desktop]};
      ${`${[$type]}-bottom`}: ${theme.spacing[vertical.desktop]};
    }
  `);
const horizontalStyles = ({
  $type,
  horizontal = {},
  theme
}) => (0, _styledComponents.css)(["", ";", ";", ";"], horizontal.general && `
    ${`${[$type]}-left`}: ${theme.spacing[horizontal.general]};
    ${`${[$type]}-right`}: ${theme.spacing[horizontal.general]};
  `, horizontal.tablet && `
    @media (min-width: ${breakpoints.tablet}) {
      ${`${[$type]}-left`}: ${theme.spacing[horizontal.tablet]};
      ${`${[$type]}-right`}: ${theme.spacing[horizontal.tablet]};
    }
  `, horizontal.desktop && `
    @media (min-width: ${breakpoints.desktop}) {
      ${`${[$type]}-left`}: ${theme.spacing[horizontal.desktop]};
      ${`${[$type]}-right`}: ${theme.spacing[horizontal.desktop]};
    }
  `);
const normalizeStyleProps = props => Object.keys(props).filter(key => _constants.allowedStylesProps.includes(key)).reduce((acc, key) => {
  const styleKey = key.startsWith('$') ? key.slice(1, key.length) : key;
  return {
    ...acc,
    [styleKey]: props[key]
  };
}, {});
const SpacingBox = exports.SpacingBox = _styledComponents.default.div.withConfig({
  displayName: "styles__SpacingBox",
  componentId: "sc-1u3zhxe-0"
})(["", " ", " ", " ", " ", " ", " ", " ", ""], allStyles, topStyles, leftStyles, rightStyles, bottomStyles, verticalStyles, horizontalStyles, normalizeStyleProps);